import { TourName } from '~/typings/enums';

export default {
    name: TourName.TherapyView,
    data(): any {
        return {
            steps: [
                {
                    target: '[data-v-step="therapy-view:view"]',
                    params: {
                        placement: 'bottom',
                    },
                    content: `
                        <div class="flex-column mb-4 text-left">
                            <h5 class="font-medium font-condensed mb-2">
                                Overzichten
                            </h5>
                            <p>
                                Klik op het oogje (indien mogelijk) om de originele aanvraag/wijziging in te zien.
                            </p>
                        </div>
                    `,
                },
            ],
        };
    },
};
